export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Post-card.vue?vue&type=template&id=1d4b8c6a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/post/Post-card.vue?vue&type=template&id=1d4b8c6a&scoped=true
// module id = 133
// module chunks = 0 1